import axios from "axios";
import { ICertificate } from "../../types";

const API_ENDPOINT = process.env.REACT_APP_CERTIFICATE_ENDPOINT;

export const getCertificate = async (epiNo: string) => {
  try {
    return (
      await axios.post(`${API_ENDPOINT}/certificates`, {
        epiNo,
      })
    ).data as ICertificate;
  } catch (error) {
    return error.response.data;
  }
};

export const getSignature = async (signature: string) => {
  try {
    return (
      await axios.get(
        `${API_ENDPOINT}/certificates/${encodeURIComponent(signature)}`
      )
    ).data as ICertificate;
  } catch (error) {
    return error.response;
  }
};
